import ColorSelectItem from "@/components/settings_element/color_select_radio/ColorSelectItem";

export default {
	name: "ColorSelect",
	props: {
		fields: {
			type: Array,
		},
		selected: {
			type: Object,
		},
	},

	components: {
		ColorSelectItem
	},

	setup(props, {emit}) {
		var pickOption = (field, index) => {
			emit('select', field, index);
		}

		return {
			pickOption
		}
	}
}
